const config = {
  API_BASE_URL: "https://server.radhikaagroindustries.com/api",
  DOC_BASE_URL: "https://server.radhikaagroindustries.com",
  
  // API_BASE_URL: "https://fms-server-8gas.onrender.com/api",
  // DOC_BASE_URL: "https://fms-server-8gas.onrender.com",
  
  // API_BASE_URL: "http://localhost:5000/api",
  // DOC_BASE_URL: "http://localhost:5000",
};

export default config;



// config.js

const configQueryMap = {
  "navbar-vertical-collapsed": "phoenixIsNavbarVerticalCollapsed",
  "color-scheme": "fmsTheme",
  "navigation-type": "phoenixNavbarPosition",
  "vertical-navbar-appearance": "phoenixNavbarVerticalStyle",
  "horizontal-navbar-shape": "phoenixNavbarTopShape",
  "horizontal-navbar-appearance": "phoenixNavbarTopStyle",
};

const initialConfig = {
  phoenixIsNavbarVerticalCollapsed: false,
  fmsTheme: "light",
  phoenixNavbarTopStyle: "default",
  phoenixNavbarVerticalStyle: "default",
  phoenixNavbarPosition: "vertical",
  phoenixNavbarTopShape: "default",
  phoenixIsRTL: false,
  phoenixSupportChat: true,
};

let CONFIG = { ...initialConfig };

export const setConfig = (newConfig, persist = true) => {
  Object.keys(newConfig).forEach((key) => {
    CONFIG[key] = newConfig[key];
    if (persist) {
      localStorage.setItem(key, JSON.stringify(newConfig[key]));
    }
  });
};

export const resetConfig = () => {
  Object.keys(initialConfig).forEach((key) => {
    CONFIG[key] = initialConfig[key];
    localStorage.setItem(key, JSON.stringify(initialConfig[key]));
  });
};

export const getConfig = () => ({ ...CONFIG });

export const initConfigFromLocalStorage = () => {
  // Apply URL params if "theme-control" is present
  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());

  if (Object.keys(params).includes("theme-control")) {
    resetConfig();
    Object.entries(params).forEach(([key, value]) => {
      if (configQueryMap[key]) {
        localStorage.setItem(configQueryMap[key], value);
      }
    });
  }

  // Load from localStorage
  Object.keys(CONFIG).forEach((key) => {
    const stored = localStorage.getItem(key);
    if (stored !== null) {
      try {
        CONFIG[key] = JSON.parse(stored);
      } catch {
        CONFIG[key] = stored;
      }
    } else {
      localStorage.setItem(key, JSON.stringify(CONFIG[key]));
    }
  });
};
